const initialState = {
    user: null,
    loading: false,
    error: null,
  };
  
  export const userReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'USER_LOGIN_REQUEST':
        return { ...state, loading: true, error: null };
      case 'USER_LOGIN_SUCCESS':
        return { ...state, loading: false, user: action.payload };
      case 'USER_LOGIN_FAIL':
        return { ...state, loading: false, error: action.payload };
  
      case 'USER_LOGOUT':
        return { ...state, user: null };
  
      default:
        return state;
    }
  };
  